import ACSChatClient from 'SERVICES/acsChatClient/chatClient';

export default ACSChatClient;
